
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/individual-family",
      function () {
        return require("private-next-pages/individual-family/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/individual-family"])
      });
    }
  